import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=43df93d4&"
import script from "./slider.vue?vue&type=script&lang=ts&"
export * from "./slider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43df93d4')) {
      api.createRecord('43df93d4', component.options)
    } else {
      api.reload('43df93d4', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=43df93d4&", function () {
      api.rerender('43df93d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/slider.vue"
export default component.exports